import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class UserService {
  private apiUrl = '/users';
  private apiPlayUrl = '/play/users';
  private apiSpringUrl = '/spring/users';

  constructor(private http: HttpService) { }

  get(query?: any): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    return this.http.get(url, query);
  }

  post(
    userCd: string,
    userTx: string,
    langTx: string,
    passwordTx: string,
    roleId: number,
    linkedOwnerId: number,
    logicalWhId: number
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    const jsonInput = {
      userCd: userCd,
      userTx: userTx,
      langTx: langTx,
      passwordTx: passwordTx,
      roleId: roleId.toString(),
      linkedOwnerId: linkedOwnerId,
      logicalWhId: logicalWhId.toString()
    };
    console.log("jsonInput: " + JSON.stringify(jsonInput));

    return this.http.post(url, jsonInput);
  }

  put(
    userId: string,
    userTx: string,
    langTx: string,
    passwordTx: string,
    roleId: number,
    linkedOwnerId: number,
    logicalWhId: number
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl + '/' + userId;
    console.log(url);
    const jsonInput = {
      userTx: userTx,
      langTx: langTx,
      roleId: roleId.toString(),
      linkedOwnerId: linkedOwnerId,
      logicalWhId: logicalWhId.toString()
    };

    console.log("jsonInput: " + JSON.stringify(jsonInput));

    return this.http.put(url, jsonInput);
  }

  password(
    userId: string,
    passwordTx: string,
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiPlayUrl + '/password/' + userId;
    console.log(url);

    const jsonInput = {
      passwordTx: passwordTx
    };

    console.log("jsonInput: " + JSON.stringify(jsonInput));

    return this.http.put(url, jsonInput);
  }

  changePassword(
    oldPasswordTx: string,
    newPasswordTx: string,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl + '/password/change';
    console.log(url);

    const jsonInput = {
      oldPasswordTx: oldPasswordTx,
      passwordTx: newPasswordTx,
      updprogramCd: updprogramCd
    };

    console.log("jsonInput: " + JSON.stringify(jsonInput));

    return this.http.put(url, jsonInput);
  }

  delete(
    userId: string,
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl + '/' + userId;
    // const jsonInput = {
    //   userTx: userTx,
    //   langTx: langTx,
    //   passwordTx: passwordTx,
    //   roleId: roleId.toString(),
    //   logicalWhId: logicalWhId.toString()
    // };
    //
    // console.log("jsonInput: " + JSON.stringify(jsonInput));

    return this.http.delete(url);
  }

  getUserrole(userId: string): Promise<any> {
    const url = environment.baseUrl
      + sessionStorage.getItem("baseUrlCompany")
      + this.apiUrl
      + '/role/'
      + userId;
    return this.http.get(url);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/user/user.service.ts